<!-- 匹配关联汽配件 -->
<template>
    <div class="searchAp-ctn" id="searchGoods">
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="flex">
                    <div class="search-name">汽配编码</div>
                    <el-input v-model="searchData.APCode" class="search-item" size="small" style="width: 200px"></el-input>
                    <div class="search-name">汽配名称</div>
                    <el-input v-model="searchData.GoodName" class="search-item" size="small" style="width: 200px"></el-input>
                    <div class="search-name">汽配分类</div>
                    <div>
                        <el-select size="small" style="width: 120px" filterable clearable v-model="searchData.Cate" @visible-change="getGoodsType($event)">
                            <el-option label="全部" value></el-option>
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </div>
                    <div class="search-name">品牌</div>
                    <div>
                        <el-select v-model="searchData.BrandName" filterable clearable size="small" style="width: 120px" @visible-change="getGoodsBrand($event)">
                            <el-option label="全部" value></el-option>
                            <el-option :key="item.Text" v-for="item in brandList" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="flex">
                    <div class="search-name">互换码</div>
                    <el-input type="text" v-model="searchData.GoodCode" class="search-item" size="small" style="width: 200px"></el-input>
                    <div class="search-name">适用车型</div>
                    <el-input v-model="searchData.AutoSerise" class="search-item" size="small" style="width: 194px"></el-input>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                </div>
            </div>
        </div>
        <div class="table-ctn relesearch-goods-table">
            <el-table
                v-loading="tableLoading"
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                border
                height="420px"
                style="width: 100%; margin-bottom: 10px"
                @sort-change="sortChange"
            >
                <el-table-column show-overflow-tooltip min-width="150" prop="APCode" sortable="custom" label="汽配编码">
                    <template slot-scope="scope">
                        <el-badge
                            :value="scope.row.IsMyRele ? '已有关联' : scope.row.IsHeRele ? '对方关联' : ''"
                            class="mark"
                            :type="scope.row.IsMyRele ? 'danger' : 'warning'"
                            v-if="scope.row.IsHeRele || scope.row.IsMyRele"
                        >
                            {{ scope.row.APCode }}
                        </el-badge>
                        {{ scope.row.IsHeRele || scope.row.IsMyRele ? '' : scope.row.APCode }}
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip min-width="120" prop="GoodCode" label="互换码"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="100" prop="GoodName" label="汽配名称"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="120" prop="AutoSerise" label="适用车型"></el-table-column>
                <el-table-column show-overflow-tooltip width="100" prop="Brand" label="汽配品牌"></el-table-column>
                <el-table-column show-overflow-tooltip width="100" prop="Cate" label="汽配分类"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="Inventory" label="库存"> </el-table-column>
                <el-table-column show-overflow-tooltip width="60px" prop="Unit" label="单位"></el-table-column>
                <el-table-column fixed="right" label="操作" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button type="warning" title="关联" size="mini" style="padding: 5px 12px" v-if="!scope.row.IsMyRele" @click="releAP(scope.row)">关联</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50, 200]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['EntpGoodsId', 'Type','IsReturnData'],//IsReturnData是否返回关联后的商品信息
    components: {},
    data() {
        return {
            tableLoading: false,
            loading: false,
            typeList: [],
            brandList: [],
            dialogType: '-1',
            dialogVisible: false,
            searchData: {
                APCode: '',
                GoodCode: '',
                GoodName: '',
                AutoSerise: '',
                EntpGoodsId: this.EntpGoodsId,
                Brand: '',
                BrandName: '',
                Cate: '',
                page: 1,
                limit: 10,
                SortProp: '',
                SortType: ''
            },
            tableData: [],
            tableDataLength: 0
        };
    },
    mounted() {
        let dialogbody = document.querySelector('#searchGoods');
        this.$util.setEventForDialog(this, dialogbody);

        this.getTableData();
    },
    methods: {
        getGoodsBrand() {
            if (this.brandList.length > 0) return;
            this.loading = true;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getGoodsType() {
            if (this.typeList.length > 0) return;
            this.loading = true;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList = data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        resetSearch() {
            this.searchData = {
                APCode: '',
                GoodCode: '',
                GoodName: '',
                AutoSerise: '',
                Brand: '',
                BrandName: '',
                Cate: '',
                page: 1,
                limit: 10,
                SortProp: '',
                SortType: ''
            };
        },
        getTableData() {
            this.tableLoading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpUnions/GetEntpRelePartList',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                    this.tableLoading = false;
                })
                .finally(e => {
                    this.tableLoading = false;
                });
        },
        releAP(goods) {
            let that = this;
            if (goods.Id && that.EntpGoodsId) {
                that.$confirm('确定要与【' + goods.APCode + '】关联吗', '提示', {
                    confirmButtonText: '确定关联',
                    cancelButtonText: '先不关联',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.$util
                            .axiosPost({
                                url: '/api/EntpUnions/ReleEnterprisePart',
                                data: {
                                    EntpGoodsId: that.EntpGoodsId,
                                    MyGoodsId: goods.Id,
                                    SourceType: that.Type
                                }
                            })
                            .then(res => {
                                if (res.errcode == 0) {
                                    that.$util.successMsg('关联成功');
                                    if(!that.IsReturnData)
                                        that.$emit('closeDialog', true);
                                    else
                                        that.$emit('closeDialog', res.data);
                                }
                            })
                            .catch(err => {});
                    })
                    .catch(() => {});
            }
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        }
    }
};
</script>
<style lang="less" scoped>
.option-content {
    display: flex;
    line-height: 30px;
}
.searchAp-ctn {
    height: 600px;
    overflow-y: auto;
}
</style>
<style lang="less">
.relesearch-goods-table {
    .el-table__row {
        td:nth-child(1) {
            .cell {
                overflow: visible;
            }
        }
    }
}
</style>
